var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "history_line_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#history_line_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.871 7.843H8a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75v-5a.75.75 0 011.5 0v3.206q.576-.914 1.356-1.693Q7.96 2.25 12 2.25t6.894 2.856Q21.75 7.96 21.75 12t-2.856 6.894Q16.04 21.75 12 21.75t-6.894-2.856Q2.25 16.04 2.25 12a.75.75 0 011.5 0q0 3.417 2.416 5.834Q8.583 20.25 12 20.25t5.834-2.416Q20.25 15.417 20.25 12t-2.416-5.834Q15.417 3.75 12 3.75T6.166 6.166q-.762.763-1.295 1.677zm7.883.743v3.693l2.605 2.605a.75.75 0 11-1.06 1.06l-2.83-2.828a.749.749 0 01-.215-.61v-3.92a.75.75 0 011.5 0z",
    fillRule: "evenodd",
    fill: "#414751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLine);
export default __webpack_public_path__ + "static/media/history-line.f7b184c449d6de3345607c36cff5a6d8.svg";
export { ForwardRef as ReactComponent };